import { render, staticRenderFns } from "./CorporateAccountOpening.vue?vue&type=template&id=b8d1d626&scoped=true"
import script from "./CorporateAccountOpening.vue?vue&type=script&lang=js"
export * from "./CorporateAccountOpening.vue?vue&type=script&lang=js"
import style0 from "./CorporateAccountOpening.vue?vue&type=style&index=0&id=b8d1d626&prod&lang=css"
import style1 from "./CorporateAccountOpening.vue?vue&type=style&index=1&id=b8d1d626&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d1d626",
  null
  
)

export default component.exports